import React from "react";
import '../assets/styles/Main.scss';
import logoMain from '../assets/images/logoMain.png';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="about-section full-image-left">

        <div className="image-wrapper">
          <img src={logoMain} alt="Rajiv Life Sciences" />
        </div>
        <div className="content">
          <h1>Rajiv Life Sciences</h1>
          <p>Learn Biotechnology - FROM DNA to DISCOVERY</p>
          <p>Learn Biotechnology - FROM DNA to DRUG DEVELOPMENT</p>
          <p>Learn Biotechnology - FROM DNA to DIAGNOSTICS</p>
        </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
